import { useState, useCallback } from 'react';
import { getDiagnosticCart } from '../services/subscriberWalletService';

export const useDiagnosticCart = (currentRole) => {
  const [cart, setCart] = useState(null);
  const [loadingCart, setLoadingCart] = useState(false);

  const loadCart = useCallback(async (orderId, showNotification) => {
    if (!orderId) return;
    setLoadingCart(true);
    try {
      const response = await getDiagnosticCart(currentRole, orderId);
      if (response?.metadata?.api_status === true) {
        setCart(response.msg || null);
      } else {
        throw new Error(response?.msg?.error || 'Failed to load cart');
      }
    } catch (error) {
      showNotification(error.message || 'Failed to load cart', 'error');
    } finally {
      setLoadingCart(false);
    }
  }, [currentRole]);

  return {
    cart,
    loadingCart,
    loadCart,
  };
};
